import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { paths } from '@shared/config';
import { campaignSearch } from '@shared/lib/campaignParams';
import type { AuthStage } from '@shared/types';
import { useAuthStore } from '../model/useAuthStore';
import { AfterSignInRedirect } from './AfterSignInRedirect';

interface RequireStageProps {
  stage: AuthStage;
  children: ReactNode;
}

const stagePath: Record<AuthStage, string> = {
  auth: paths.auth,
  onboarding: paths.onboarding,
  app: paths.dashboard,
};

export function RequireStage({ stage: required, children }: RequireStageProps) {
  const current = useAuthStore((s) => s.stage);
  const location = useLocation();
  if (current === required) return <>{children}</>;
  // Вошёл — туда, куда шёл до входа (returnTo), иначе на главную.
  if (current === 'app') return <AfterSignInRedirect search={location.search} />;
  // Метки кампании переносим (см. campaignSearch), остальные параметры отбрасываем.
  return <Navigate to={{ pathname: stagePath[current], search: campaignSearch(location.search) }} replace />;
}
